import React from "react";

interface LogoProps {
  size?: number; // Optional size prop
  style?: React.CSSProperties; // Add style prop for inline styling
}

const Logo: React.FC<LogoProps> = ({ size = 50, style }) => {
  return (
    <div className="flex items-center h-full" style={style}>
      {" "}
      {/* Apply style here */}
      <a href="/" rel="noopener noreferrer">
        <img
          src="/images/logo/newLogo.png"
          alt="Logo"
          width={size}
          height={size}
          className="object-contain"
        />
      </a>
    </div>
  );
};

export default Logo;
